"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _RenderHelpers = _interopRequireDefault(require("crm_ui/routes/shared/RenderHelpers"));

var NavigationActions = _interopRequireWildcard(require("hubspot.flux.actions.NavigationActions"));

var _CommunicatorActions = require("customer-data-communicator/data/communicator/actions/CommunicatorActions");

var _ProfileContainer = _interopRequireDefault(require("crm_ui/profile/ProfileContainer"));

var _connectPromiseSingle = require("crm_data/flux/connectPromiseSingle");

var _CommunicatorStore = _interopRequireDefault(require("customer-data-communicator/data/communicator/stores/CommunicatorStore"));

var _delayUntilIdle = require("crm_ui/utils/delayUntilIdle");

var _CalleeActions = require("crm_data/calls/CalleeActions");

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var ProfileRoute =
/*#__PURE__*/
function () {
  function ProfileRoute() {
    (0, _classCallCheck2.default)(this, ProfileRoute);
  }

  (0, _createClass2.default)(ProfileRoute, null, [{
    key: "render",
    value: function render(objectType, id) {
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      (0, _delayUntilIdle.delayUntilIdle)(function () {
        var RteSetup = require('crm_ui/rte/RteSetup');

        var RichTextEditorDefaultConfigurations = require('customer-data-rte/config/RichTextEditorDefaultConfigurations');

        var RichTextEditorContentMediator = require('customer-data-rte/state/RichTextEditorContentMediator');

        var RichTextEditor = require('customer-data-rte/components/RichTextEditor');

        var SimpleRichTextEditor = require('customer-data-rte/components/SimpleRichTextEditor');

        require('crm_ui/timeline/components/generic/TimelineInlineEditor'); // The communicator requires stuff dynamically at runtime. Until we have code splitting in libraries,
        // we have to require those module statically via require, then expose them via hubspot.define
        // Unfortunately, it would confuse asset bender, so we make it as hard as possible to statically
        // analyze the lines below.


        var _require = require('hubspot'),
            define = _require.define;

        define('hubspot.customerdata.rte.components.RichTextEditor', [], function () {
          return RichTextEditor;
        });
        define('hubspot.customerdata.rte.state.RichTextEditorContentMediator', [], function () {
          return RichTextEditorContentMediator;
        });
        define('hubspot.customerdata.rte.config.RichTextEditorDefaultConfigurations', [], function () {
          return RichTextEditorDefaultConfigurations;
        });
        define('hubspot.customerdata.rte.components.SimpleRichTextEditor', [], function () {
          return SimpleRichTextEditor;
        });
        RteSetup.initRteConfig();

        if (query.interaction) {
          (0, _connectPromiseSingle.connectPromiseSingle)({
            stores: [_CommunicatorStore.default],
            deref: function deref() {
              return _CommunicatorStore.default.get('interaction');
            }
          })().then(function (interaction) {
            if (!interaction) {
              (0, _CommunicatorActions.showCommunicator)(query.interaction);

              if (query.interaction === _InteractionTypes.CALL) {
                (0, _CalleeActions.setCallee)(id, id, objectType); // setSelectedPhoneNumberProperty(id, 'phone'); maybe add this for contact / company??
              }
            }
          });
        }
      });
      var deps = {
        subjectId: id,
        objectType: objectType,
        query: query
      };
      NavigationActions.navigate(_ProfileContainer.default, deps);

      _RenderHelpers.default.render();
    }
  }]);
  return ProfileRoute;
}();

exports.default = ProfileRoute;
module.exports = exports.default;